// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2VH2D","item":"PaymentsMobile_item__2X0am","label":"PaymentsMobile_label__18-0g","amount":"PaymentsMobile_amount__1YONH"};